import { UniversalSearch } from '@comfama/comfama-ui-react';
import React, { useEffect } from 'react';
import { LuX } from 'react-icons/lu';

import type { HeaderSearchController } from '../hooks/useHeaderSearch';

export interface HeaderSearchOverlayProps {
    isOpen: boolean;
    onClose: () => void;
    search: HeaderSearchController['search'];
}

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    backgroundColor: '#ffffff',
    overflowY: 'auto',
};

const contentStyle: React.CSSProperties = {
    maxWidth: '1152px',
    margin: '0 auto',
    padding: '16px',
};

const closeRowStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: '16px',
    paddingBottom: '8px',
};

const closeBtnStyle: React.CSSProperties = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const HeaderSearchOverlay = ({
    isOpen,
    onClose,
    search,
}: HeaderSearchOverlayProps) => {
    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div style={overlayStyle} data-testid="header-search-overlay">
            <div style={contentStyle}>
                <div style={closeRowStyle}>
                    <button
                        type="button"
                        onClick={onClose}
                        style={closeBtnStyle}
                        aria-label="Cerrar búsqueda"
                    >
                        <LuX size={28} />
                    </button>
                </div>

                <UniversalSearch
                    mostSearched={search.mostSearched}
                    contents={search.contents}
                    onSearch={search.onSearch}
                    isLoadingSuggestions={search.isLoadingSuggestions}
                    searchSuggestions={search.searchSuggestions}
                    onSearchFull={search.onSearchFull}
                    filters={search.filters}
                />
            </div>
        </div>
    );
};

export default HeaderSearchOverlay;
